import {
	bondFormFileSchema,
	ContractSuretyBondFormType,
	ContractSuretyType,
	formatToDollar,
	type SuretyBondFormType,
	suretyBondFormTemplateId,
} from "@inrev/common";
import { BondFormTemplate } from "@portal/api/bond-request/agent";
import { pick } from "rambda";
import { bondFormTypeLabelMap } from "../../../constants";
import type { BondFormData } from "../../../types";
import { formatEmpty } from "../../../utils";

export const getFilteredBondFormTemplates = (
	templates: BondFormTemplate[],
	bondType?: ContractSuretyType,
) => {
	if (bondType === ContractSuretyType.final || bondType === ContractSuretyType.bid_to_final) {
		return templates.filter((t) => ["payment", "performance", "pnp"].includes(t.type));
	}
	if (bondType === ContractSuretyType.bid) {
		return templates.filter((t) => t.type === ContractSuretyBondFormType.bid);
	}
	return [];
};

export const getAllowedBondFormUploadTypes = (
	bondType?: ContractSuretyType,
): Partial<Record<SuretyBondFormType, string>> => {
	if (bondType === ContractSuretyType.final || bondType === ContractSuretyType.bid_to_final) {
		return pick(["pnp", "performance", "payment"], bondFormTypeLabelMap);
	}
	if (bondType === ContractSuretyType.bid) {
		return pick(["bid"], bondFormTypeLabelMap);
	}
	return {};
};

export const formatMinimalUIAmount = (value: number, isMinimalUIEnabled: boolean) =>
	formatEmpty(isMinimalUIEnabled && value === 0 ? null : formatToDollar(value));

export const transformBondFormForSubmission = (bondForm: BondFormData) => {
	if (bondForm.templateId) {
		return { templateId: suretyBondFormTemplateId.parse(bondForm.templateId) };
	}
	const { type, files } = bondForm.upload;
	if (type && files.length > 0) {
		return { upload: { type, files: bondFormFileSchema.array().parse(files) } };
	}
	return null;
};
